import { render, staticRenderFns } from "./AcercaDeMi.vue?vue&type=template&id=0914321a&scoped=true&"
import script from "./AcercaDeMi.vue?vue&type=script&lang=js&"
export * from "./AcercaDeMi.vue?vue&type=script&lang=js&"
import style0 from "./AcercaDeMi.vue?vue&type=style&index=0&id=0914321a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0914321a",
  null
  
)

export default component.exports